import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@wove/web-ui";
import { Info } from "lucide-react";

interface HsCodeInfoModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  hsCode?: string;
  description?: string;
}

export default function HsCodeInfoModal({ open, onOpenChange, hsCode, description }: HsCodeInfoModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>HS Code Information</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {hsCode ? (
            <>
              <div>
                <h4 className="font-medium text-sm text-gray-700">HS Code</h4>
                <p className="text-lg font-mono">{hsCode}</p>
              </div>
              {description && (
                <div>
                  <h4 className="font-medium text-sm text-gray-700">Description</h4>
                  <p className="text-sm">{description}</p>
                </div>
              )}
              <div className="text-sm text-gray-600 space-y-2">
                <p>
                  The Harmonized System (HS) code is an internationally standardized system of names and numbers 
                  to classify traded products. It is used by customs authorities around the world to identify 
                  products when assessing duties and taxes.
                </p>
                <p>
                  HS codes are organized into:
                </p>
                <ul className="list-disc list-inside ml-2">
                  <li>First 2 digits: Chapter</li>
                  <li>First 4 digits: Heading</li>
                  <li>First 6 digits: Subheading</li>
                  <li>Additional digits: Country-specific subdivisions</li>
                </ul>
              </div>
            </>
          ) : (
            <div className="text-sm text-gray-600">
              <p>
                No HS code has been assigned to this item yet. HS codes are used to classify goods 
                for customs and statistical purposes.
              </p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}